import { useAuth } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";
import React, { type PropsWithChildren } from "react";
import LoadingScreen from "@/hooks/components/common/LoadingScreen.tsx";

export const GuestGuard: React.FC<PropsWithChildren> = ({ children }) => {
    const { isLoaded, isSignedIn } = useAuth();

    if (!isLoaded) {
        return <LoadingScreen />;
    }

    if (isSignedIn) {
        return <Navigate to="/app/dashboard" replace />;
    }

    return <>{children}</>;
};